import api from "./api"

const cleanParams = (params = {}) => {
  const clean = {}

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      clean[key] = value
    }
  })

  return clean
}

export const getMaisonDjoDashboard = async (params = {}) => {
  const response = await api.get("/dashboard/maison-djo", {
    params: cleanParams({
      date_from: params.date_from || params.dateFrom,
      date_to: params.date_to || params.dateTo,
      store_id: params.store_id || params.storeId,
    }),
  })

  return response.data
}
